import { createAsyncThunk } from '@reduxjs/toolkit'

export type SliceNames =
  | 'test'
  | 'user'
  | 'session'
  | 'forms'
  | 'analyzers'
  | 'scripts'
  | 'configs'
  | 'results'
  | 'datasets'
  | 'login'

export type EntityNames =
  | 'Config'
  | 'Analyzer'
  | 'Dataset'
  | 'Result'
  | 'Script'
  | 'User'
  | 'Test'
  | 'Session'
  | 'Form'
  | 'Login'

export const setEntityError = createAsyncThunk(
  `generic/setEntityError`,
  async (
    errorData: {
      sliceName: SliceNames
      entityName: EntityNames
      error: {
        code: string //should be one of error | invalid | auth?
        message: string
        fields: { field: string; message: string }[]
      } | null
    },
    { dispatch }
  ) => {
    dispatch(
      createAsyncThunk(
        `${errorData.sliceName}/set${errorData.entityName}Error`,
        async (_, { rejectWithValue }) => {
          return rejectWithValue(errorData.error)
        }
      )()
    )
  }
)
